import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Button} from 'react-bootstrap';
import DataItem from '../../../_common/components/DataItem';
import DataItemTextarea from '../../../_common/components/DataItemTextarea';
import {usePopupSendMessageContext} from '../../context/PopupSendMessageContext';
import DataItemCheckbox from '../../../_common/components/DataItemCheckbox';

export function PopupForm({cellContent, handleClose}) {
  const {formik, handleSendMessage} = usePopupSendMessageContext();
  const {isValid, resetForm, values} = formik;
  const prefix = 'unpaid-agents-popup-send-message';
  const sendByBoxClassnames = 'w-100 d-flex flex-column align-items-center border border-secondary rounded px-4 py-8';

  return (
    <>
      <h3 className={'bold mb-4 text-center'}>
        <FormattedMessage id={`${prefix}-header`} defaultMessage={'Send message to agent'}/>
        {cellContent?.agentID ? ` - ${cellContent.agentID}` : ''}
      </h3>
      <div className={'d-flex mx-auto flex-column align-items-center justify-content-center px-8'}>
        <div className={'w-100 d-flex justify-content-between align-items-center my-2'}>
          <div className={`${sendByBoxClassnames} ${values.sendSMS ? 'bg-secondary' : ''} mr-2`}>
            <DataItemCheckbox
              fieldName={'sendSMS'}
              label={<FormattedMessage id={`${prefix}-send-sms`} defaultMessage={'Send SMS'}/>}
              containerClassname={'d-flex justify-content-between flex-row-reverse align-items-center'}
              labelClassname={'ml-2'}
            />
            <DataItem
              fieldId={'phone'}
              label={<FormattedMessage id={`${prefix}-field-phone`} defaultMessage={'Phone'}/>}
              topLabelStyle={'custom-brand-color'}
              containerStyle={'w-100'}
              disabled={!values.sendSMS}
            />
          </div>
          <div className={`${sendByBoxClassnames} ${values.sendEmail ? 'bg-secondary' : ''} ml-2`}>
            <DataItemCheckbox
              fieldName={'sendEmail'}
              label={<FormattedMessage id={`${prefix}-send-email`} defaultMessage={'Send email'}/>}
              containerClassname={'d-flex justify-content-between flex-row-reverse align-items-center'}
              labelClassname={'ml-2'}
            />
            <DataItem
              fieldId={'email'}
              label={<FormattedMessage id={`${prefix}-field-email`} defaultMessage={'Email'}/>}
              topLabelStyle={'custom-brand-color'}
              containerStyle={'w-100'}
              disabled={!values.sendEmail}
            />
            <div className={'position-relative w-100'}>
              {formik.errors.invalidEmail &&
                <div className={'invalid-email-message invalid-email-unpaid-agents'}>
                  <FormattedMessage id={'invalid-email-message'} defaultMessage={'Invalid email'}/>
                </div>
              }
            </div>
          </div>
        </div>
        <DataItemTextarea
          fieldId={'message'}
          label={<FormattedMessage id={`${prefix}-field-message`} defaultMessage={'Message'}/>}
          minRows={10}
          maxRows={10}
          customLabelStyle={'custom-brand-color'}
          customContainerStyle={'my-2 w-100'}
        />
      </div>
      <div className="d-flex justify-content-center mt-8">
        <Button
          className="btn-secondary btn-sm col-2 mx-3"
          onClick={() => {
            handleClose();
            resetForm();
          }}
        >
          <FormattedMessage id={'label-button-cancel'} defaultMessage={'Cancel'}/>
        </Button>
        <Button
          className="btn-sm col-2 mx-3 custom-send-button"
          onClick={async () => {
            await handleSendMessage();
            handleClose();
            resetForm();
          }}
          disabled={!isValid}
        >
          <FormattedMessage id={'label-button-send'} defaultMessage={'Send'}/>
        </Button>
      </div>
    </>
  );
}